// Product ID to single Variant ID mapping
var tangent_selected_product_map;
var default_addToCartText = "Add to cart";
var default_addedToCartText = "Added to cart!";
var default_add_all_to_cart_text = "Add All to cart"
var out_of_stock_text = "Out of stock";
var no_products_found_text ="No Products found";
var tangent_client_domain_currency;

// Add default image url here
var tangent_default_selfie_image_url="";
var default_variant_image_url ="https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp"

var tangent_client_domain_url = window.location.origin;

if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", (event) => {
        onLoadFunction();
    });
} else {
    onLoadFunction();
}

function onLoadFunction(){
  var tangent_response_id = getClientResponseId()
  checkoutDataApiCall(tangent_response_id);
}

function getClientResponseId(){
  // Current Page Load URL
  var tangent_client_url = new URL(window.location.href);
  return tangent_client_url.searchParams.get("resp_id");
}

function checkoutDataApiCall(tangent_response_id){
  if (tangent_response_id != null) {
    var checkout_url = "https://service.tangent.ai/shopify/get-checkout-products?resp_id="+tangent_response_id+ "&self_serve=true" + "&multiple_variants=true";
    fetch(checkout_url)
    .then(data => {
      return data.json();
    })
    .then(response => {
      removeTemplateSpacing();
      console.log("response recieved",response);
      checkoutDataProcess(response);
      return response;
    })
    .catch((error) => {
      console.error('Error:', error);
    });
  }
}

function removeTemplateSpacing() {
  const ids = [
    "shopify-section-template--16582606749773__custom_liquid_yGtaK8",
    "shopify-section-template--16583048003661__custom_liquid_yGtaK8",
    "shopify-section-template--16582995116109__custom_liquid_yGtaK8",
    "shopify-section-template--16583049445463__custom_liquid_yGtaK8"
  ];
  let removedSpacing =false;
  ids.forEach((id) => {
    const containerLayout = document.getElementById(id);
    if (containerLayout && containerLayout.childNodes[0]) {
      const firstChild = containerLayout.childNodes[0];
      firstChild.classList.remove("section-spacing", "container");
      removedSpacing = true;
    }
  });
  if(!removedSpacing){
    let containerParent = document.querySelectorAll(".section--custom-html");
    if(containerParent.length>0){
      const firstChild = containerParent[0].childNodes[0]
      firstChild.classList.remove("section-spacing", "container");
    }
  }
}

function checkoutDataProcess(response){
    var tangent_recommended_products = response.products;

    tangent_client_domain_currency = document.querySelector("#tangent_client_currency").innerText+" "; 

    // Setting Default variant price symbol
    if (tangent_client_domain_currency == "") {
        tangent_client_domain_currency = '$';
    }

    setSelfieImage(response);
    if (tangent_recommended_products.length > 0) {
      setProductsToView(tangent_recommended_products, response.selected_variants);
      enableButtonListener();
      loadElementsOnResponseData();    
      setElementDisplay("tangent-product-wrapper","flex");
    }
    else {
        document.querySelector('#tangent-general-text').innerHTML = no_products_found_text;
    }
  
    if (response.description == '') {
        document.querySelector('#tangent-general-text').style.display = "block";
    }
    else{
        document.querySelector('#section_selfie_container_parent').style.display = "block";
        document.querySelector('#section_selfie_container_parent').innerHTML = response.description;
    }

    hideLoading();
  
    setElementDisplay("tangent-general-text","block");
}

function setSelfieImage(response){
  if(response.selfie_html!=null){
    const selfie_image_container = document.querySelector('#tangent_selfie_image_container');
    selfie_image_container.style.display="block";
    selfie_image_container.innerHTML = response.selfie_html;
    
    const selfie_main_container = document.querySelector('#tangent_section_selfie_parent_wrapper');
    selfie_main_container.style.padding="5%";
    
  }
}

function getProductUsingId(productList, productId) {
  for (const product of productList) {
    if (product.id == productId) {
      return product;
    }
  }
  return null; // Return null if no product is found
}

function setProductsToView(products, selectedVariants) {
  tangent_selected_product_map = [];
  let productWrapperElement = document.getElementById("tangent-product-wrapper");
  // Create a variable to accumulate the HTML
  let section_html = "";
  Object.keys(selectedVariants).forEach(productId => {
    const selectedVariantIds = selectedVariants[productId];
    const product = getProductUsingId(products, productId);
    const allProductVariants = product.variants;
    
    if(selectedVariantIds && selectedVariantIds.length>0){
       for (let id of selectedVariantIds) {
         let variant = getMatchedVariant(product.variants, id);
         if(variant){
           let mapCartProduct = {}
           // Generate the product HTML
           let product_html = getProductHTML(product, variant);
           // Accumulate the HTML
           section_html += product_html;
           
           mapCartProduct[product.id] = variant.id;
           tangent_selected_product_map.push(mapCartProduct);
         }
       }
    }
  });

  // Append all the HTML to the section's product grid in one go
  productWrapperElement.insertAdjacentHTML('beforeend', section_html);
}

function getMatchedVariant(variants, variantId){
  for (const variant of variants) {
    if (variant.id == variantId) {
      return variant;
    }
  }
  return variants[0]; // Return first if no matching variant is found
}

function getProductHTML(product, variant) {
  let index = variant.id;
  let product_price = variant.price;
  let variant_image_url = getVariantImage(variant.image_id, product);
  let variant_id = variant.id;
  let variant_product_url = `${tangent_client_domain_url}/products/${product.handle}?variant=${variant_id}`;
  let add_to_cart_classlist="";
  default_addToCartText = "Add to cart";
  if(!isProductActive(product, variant)){
    default_addToCartText = out_of_stock_text;
    add_to_cart_classlist = "disable-btn-wrapper";
  }
  
  // Generate Product HTML
  let product_html = `
    <div>
      <a id="url_tangent_product_${index}" class="tangent-text-link" target="_blank" href="${variant_product_url}">
        <img id="image_tangent_product_${index}" src="${variant_image_url}" class="tangent_product_image" alt="${product.title}">
        <p class="tangent-product-title tangent_product_title_text"><b>${product.title}</b></p>
        <p class="tangent-product-variant-title">${variant.title}</p>
        <p id="price_tangent_product_${index}" class="tangent_product_price_text">${tangent_client_domain_currency}${product_price}</p>
      </a>
      <div id="product_variant_${index}"></div>
      <a class="tangent-product-add-btn-wrapper" id="${variant_id}" href="javascript: void(0)">
        <p class="tangent-btn-add tangent_add_to_cart_button ${add_to_cart_classlist}" id="product_cart_tangent_product_${index}_text">
          ${default_addToCartText}
        </p>
      </a>
    </div>
  `;
  
  return product_html;
}

function isProductActive(product, variant){
  if (product.status !== "active") {
        return false;
  }
  const { inventoryPolicy, inventoryQuantity } = variant;
  
  // Check inventory policy and quantity
  if (inventoryPolicy === "deny" && inventoryQuantity < 1) {
      return false;
  } else {
      return true;
  }
}

const getVariantImage = (imageId, product) => {
    var product_image;
    
    if(imageId!=null){
        var all_images = product.images;
        if(all_images!=undefined){
            for(var im=0;im<all_images.length;im++){
                if(imageId==all_images[im].id){
                    product_image = all_images[im].src;
                }
            }
        }
    }
    else{
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }
    if(product_image== undefined || product_image==null){
        if(product.image!=null){
            product_image = product.image.src;
        }
        else{
            product_image = 'https://file.tangent.ai/quiz-content/merchants/nitesh-dev-store/image/5009378275701413-no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c_720x.webp';
        }
    }
    return product_image;
}

// Add To Cart Function
function addToCart(btn){ 
    // Prepare the request payload
    const payload = {
        id: btn.id,
        quantity: 1 // Default quantity to add
    };
    let btnText = document.getElementById("product_cart_tangent_product_"+btn.id+"_text");
    btnText.innerHTML = "Please wait...";
    // Send the AJAX request to Shopify's cart/add.js endpoint
    fetch('/cart/add.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
    })
    .then(response => {
        if (!response.ok) {
            throw new Error(`Failed to add product to cart: ${response.statusText}`);
        }
        return response.json();
    })
    .then(data => {
        document.dispatchEvent(new CustomEvent('cart:build' , {bubbles: true})); 
        document.dispatchEvent(new CustomEvent('cart:refresh', {
            bubbles: true
        })); 
        
        let btnText = document.getElementById("product_cart_tangent_product_"+btn.id+"_text");
        if(btnText!=undefined){
          btnText.innerHTML = default_addedToCartText;
          btnText.classList.add("added-to-cart-style");   
        }    
        // Optionally, trigger a UI update or show a success message
        //alert('Product added to cart successfully!');
        if(liquidAjaxCart != null){
          liquidAjaxCart.cartRequestUpdate();
        }
    })
    .catch(error => {
        console.error('Error adding product to cart:', error);
        alert('Failed to add product to cart. Please try again.');
    });
}

// Toggle - selfie canvas 
function setElementDisplay(element_id, displayType){
  document.querySelector("#"+element_id).style.display=displayType;  
}

// Setting Selfie / Default Image
function setTangentSelfieSection(response) {
    if(response.selfie_html!=null && response.selfie_html!=undefined){
      document.getElementById("tangent_selfie_container").innerHTML = response.selfie_html;
    }
    else{
        if(response.selfie_url!=undefined && response.selfie_url!=null){
          document.querySelector('#tangent_selfie_image').src = response.selfie_url;
        }
        else{
            if(tangent_default_selfie_image_url!=""){
                document.querySelector('#tangent_selfie_image').src = tangent_default_selfie_image_url;
            }
            else{
                document.querySelector("#tangent_selfie_container").style.display = "none";
            }
        }
    }
}

function enableButtonListener() {
    // Listener for section add all to carts
    var all_btns = document.querySelectorAll('.tangent-product-add-btn-wrapper');
    all_btns.forEach(function(btn) {
        btn.addEventListener('click', function() {
            addToCart(this);
        }, false);
    });
}

function loadElementsOnResponseData() {
    var all_elements = document.querySelectorAll('.load-on-data');
    all_elements.forEach(function(element) {
      element.style.display = "flex";
    });
  }
  
// Hide loading
function hideLoading(){
  document.querySelector("#loading-section").style.display = "none";
}
